import {
  TSU_REL_RUNUP_DATA_TSUNAMI_REQUEST,
  TSU_REL_RUNUP_DATA_RUNUP_REQUEST,
  TSU_REL_RUNUP_DATA_DELETE_RUNUP_REQUEST,
  TSU_REL_RUNUP_DATA_CLEAR,
  TSU_REL_RUNUP_DATA_TOGGLE_COLUMN,
  TSU_REL_RUNUP_DATA_SORT,
} from './tsunamiRelatedRunupsReducer';


export const clearPageData = () => ({ type: TSU_REL_RUNUP_DATA_CLEAR });
export const getTsunami = ({ id, history }) => ({ type: TSU_REL_RUNUP_DATA_TSUNAMI_REQUEST, id, history });
export const getRunups = ({ id, history }) => ({ type: TSU_REL_RUNUP_DATA_RUNUP_REQUEST, id, history });
export const deleteRunup = ({ id, history }) => ({ type: TSU_REL_RUNUP_DATA_DELETE_RUNUP_REQUEST, id, history });
export const toggleColumns = visibleColumns => ({ type: TSU_REL_RUNUP_DATA_TOGGLE_COLUMN, visibleColumns });
export const sortData = sort => ({ type: TSU_REL_RUNUP_DATA_SORT, sort });
